import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const studySubjectsApi = createApi({
  reducerPath: 'studySubjectsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getStudySubjects: builder.query({
      query: () => ({
        url: urls.studySubjects,
      }),
    }),
  }),
});

export const { useGetStudySubjectsQuery } = studySubjectsApi;
